import React, {Component} from 'react';
import {Link} from "react-router-dom";
import logoHeader from './images/logo.png';
import {strings} from "./Utils";

export default class Header extends Component {

	setLanguage(lang) {
		this.props.changeLanguage(lang);
	}

	mobileAndTabletCheck() {
		let check = false;
		(function(a){
			if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4\|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hsc|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i\|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-\| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	};

	render() {
		let isMobileBrowser = this.mobileAndTabletCheck();
		return(
			<div>
			<header className="top-header">
				<div className="row align-items-center mr-2 ml-2">
					<div className="col-lg-2 col-md-2">
						<ul className="top-header-left">
							<li>
								<a href="https://facebook.com/tashxismarkazi/" target="_blank" rel="noopener noreferrer">
									<i className="fab fa-facebook-f"/>
								</a>
							</li>
							<li>
								<a href="https://t.me/tashxismarkazi" target="_blank" rel="noopener noreferrer">
									<i className="fab fa-telegram"/>
								</a>
							</li>
						</ul>
					</div>
					<div className="col-lg-10 col-md-10">
						<ul className="top-header-right">
							<li>
								<i className="fa fa-map"/>
								{strings.ourAddress}
							</li>
							<li>
								<i className="fa fa-envelope"/>
								<a href="mailto:tashxis_markazi@xtv.uz">tashxis_markazi@xtv.uz</a>
							</li>
							<li>
								<i className="fa fa-phone"/>
								<a href="tel:+998712469804">+998 (71) 246-98-04</a>
							</li>
							<li>
								<i className="fa fa-user"/>
								<Link to="/login">{strings.login}</Link>
							</li>
							<li className="cursor-pointer" onClick={this.setLanguage.bind(this, 'uz')}>
								<span>
									<img className="lang-flag" src="/images/uz.jpg" alt=""/>
									O`zbekcha
								</span>
							</li>
							<li className="cursor-pointer" onClick={this.setLanguage.bind(this, 'ru')}>
								<span>
									<img className="lang-flag" src="/images/ru.jpg" alt=""/>
									Русский
								</span>
							</li>
						</ul>
					</div>
				</div>
			</header>
				<div className="navbar-area">
					{/*<div className="mobile-nav">
						<Link to="/" className="logo">
							<img src={logoHeader} alt="Logo"/>
						</Link>
					</div>*/}
					<div className="top-nav main-nav">
						<nav className="navbar navbar-expand-md navbar-light">
							<Link className="navbar-brand" to="/">
								<img src={logoHeader} alt="Logo"/>
							</Link>
							<div style={{width: "225px", textAlign: "center"}}>
								<h5 style={{fontWeight: "bold"}}>{strings.kasbim}</h5>
								<h5 style={{fontWeight: "bold", marginBottom: "0", color: "#4eae4a"}}>{strings.kelajagim}</h5>
							</div>
							<div className="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
								<ul className="navbar-nav m-auto">
									<li className="nav-item">
										<Link to="/">{strings.homePage}</Link>
									</li>
									<li className="nav-item">
										<Link to="/about">{strings.aboutProgram}</Link>
									</li>
									<li className="nav-item">
										{/*<Link to="/quiz">{strings.tests}</Link>*/}
										<span>
											{strings.tests}
											<i className="bx bx-chevron-down"/>
										</span>

										<ul className="dropdown-menu">
											<li>
												<Link to="/quiz" className="nav-link">
													{strings.tests}
												</Link>
											</li>
											<li>
												<Link to="/mathTest" className="nav-link">
													{strings.mathTest}
												</Link>
											</li>
											{/*<li>
												<Link to="/iqTest" className="nav-link">
                                                    {strings.iqTest}
												</Link>
											</li>*/}
										</ul>
									</li>

									<li className="nav-item">
										<span>
											{strings.professionWorld}
											<i className="bx bx-chevron-down"/>
										</span>

										<ul className="dropdown-menu">
											<li>
												<Link to="/professions" className="nav-link">
													{strings.professionWorld}
												</Link>
											</li>
											<li>
												<Link to="/occupation" className="nav-link">
													{strings.professionWorld2}
												</Link>
											</li>
										</ul>
									</li>
									<li className="nav-item">
										{/*<Link to="/oсcMonth">{strings.occupationMonth}</Link>*/}
										<Link to="/ent" className="nav-link">{strings.entrepreneurship}</Link>
									</li>
									<li className="nav-item">
										<Link to="/psychologicalAdvice">{strings.psychCounseling}</Link>
									</li>
									<li className="nav-item">
										<span>
											{strings.effective}
											<i className="bx bx-chevron-down"/>
										</span>

										<ul className="dropdown-menu">
											<li>
												<Link to="/effective" className="nav-link">
													{strings.effective2}
												</Link>
											</li>
											<li>
												<Link to="/effective2" className="nav-link">
													{strings.effective3}
												</Link>
											</li>
										</ul>
									</li>
									{/*<li className="nav-item">
										<a href="#">
											{strings.documents}
											<i className="bx bx-chevron-down"/>
										</a>

										<ul className="dropdown-menu">
											<li>
												<Link to={"/documentsView?type=1&lang=" + this.props.language}
													  className="nav-link">{strings.documentsType1}</Link>
											</li>
											<li>
												<Link to={"/documentsView?type=2&lang=" + this.props.language}
													  className="nav-link">{strings.documentsType2}</Link>
											</li>
											<li>
												<Link to={"/documentsView?type=3&lang=" + this.props.language}
													  className="nav-link">{strings.documentsType3}</Link>
											</li>
											<li>
												<Link to={"/documentsView?type=4&lang=" + this.props.language}
													  className="nav-link">{strings.documentsType4}</Link>
											</li>
											<li>
												<Link to={"/documentsView?type=5&lang=" + this.props.language}
													  className="nav-link">{strings.documentsType5}</Link>
											</li>
										</ul>
									</li>*/}
									<li className="nav-item">
										<Link to="/mtttest" className="nav-link">Psixologik holatni aniqlash</Link>
									</li>

									<li className="nav-item">
										<Link to="/contact">{strings.contact}</Link>
									</li>

									{isMobileBrowser &&
										<li className="cursor-pointer nav-item"
											onClick={this.setLanguage.bind(this, 'uz')}>
										<span onClick={this.setLanguage.bind(this, 'uz')}>
											<img className="lang-flag" src="/images/uz.jpg" alt=""/>
											O`zbekcha
										</span>
										</li>
									}
									{isMobileBrowser &&
										<li className="cursor-pointer nav-item"
											onClick={this.setLanguage.bind(this, 'ru')}>
										<span onClick={this.setLanguage.bind(this, 'ru')}>
											<img className="lang-flag" src="/images/ru.jpg" alt=""/>
											Русский
										</span>
										</li>
									}
								</ul>
							</div>
						</nav>
					</div>
				</div>
			</div>
		)
	}
}